import Statistic from './statistic';

export default Statistic;
export type * from './types';
